import { FR } from './france';

export const MQ = FR;
